
export function getValueColor(v) {
  if (v > 0) return 'green--text';
  if (v < 0) return 'red--text';
}